/* MJ Creations · product.js — PDP interactions (gallery, variants, fit mode, delivery, modals) */
(function () {
  var pdp = document.querySelector('[data-pdp]');
  if (!pdp) return;

  var form = document.getElementById('mjProductForm');
  var variants = [];
  try { variants = JSON.parse(document.querySelector('[data-product-json]').textContent); } catch (e) {}
  var moneyFormat = '${{amount}}';
  try { moneyFormat = JSON.parse(document.querySelector('[data-money-format]').textContent); } catch (e) {}

  function money(cents) {
    var v = (cents / 100).toFixed(2).replace(/\.00$/, '');
    return moneyFormat.replace(/\{\{\s*amount(_no_decimals)?\s*\}\}/, v).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v).replace(/<[^>]+>/g, '');
  }

  /* ---------- gallery ---------- */
  var mainImg = document.getElementById('mjMainImg');
  var stage = document.getElementById('mjStage');
  var thumbs = pdp.querySelectorAll('#mjThumbs button');
  thumbs.forEach(function (b) {
    b.addEventListener('click', function () {
      thumbs.forEach(function (x) { x.classList.remove('is-active'); });
      b.classList.add('is-active');
      if (!mainImg) return;
      var src = b.getAttribute('data-full');
      if (!src) { var im = b.querySelector('img'); src = im ? im.src : ''; }
      mainImg.style.opacity = 0;
      setTimeout(function () {
        mainImg.removeAttribute('srcset'); // srcset would otherwise override src
        mainImg.removeAttribute('sizes');
        mainImg.src = src;
        mainImg.style.opacity = 1;
        if (stage) stage.classList.remove('is-zoomed');
        mainImg.style.transform = '';
      }, 150);
    });
  });
  if (stage && mainImg) {
    stage.addEventListener('click', function (e) {
      if (stage.classList.toggle('is-zoomed')) {
        var r = stage.getBoundingClientRect();
        mainImg.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
        mainImg.style.transform = 'scale(1.9)';
      } else { mainImg.style.transform = ''; }
    });
    stage.addEventListener('mousemove', function (e) {
      if (!stage.classList.contains('is-zoomed')) return;
      var r = stage.getBoundingClientRect();
      mainImg.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
    });
  }

  /* ---------- variant selection ---------- */
  var OPTSEL = '.t-opt__btn, .t-swatch';
  var selected = [];
  pdp.querySelectorAll('.t-opt').forEach(function (opt, i) {
    var active = opt.querySelector('.t-opt__btn.is-active, .t-swatch.is-active');
    var first = opt.querySelector(OPTSEL);
    selected[i] = active ? active.dataset.value : (first ? first.dataset.value : null);
    opt.querySelectorAll(OPTSEL).forEach(function (btn) {
      btn.addEventListener('click', function () {
        opt.querySelectorAll(OPTSEL).forEach(function (x) { x.classList.remove('is-active'); });
        btn.classList.add('is-active');
        selected[i] = btn.dataset.value;
        var lbl = opt.querySelector('[data-opt-value]');
        if (lbl) lbl.textContent = btn.dataset.value;
        updateVariant();
      });
    });
  });

  function currentVariant() {
    return variants.find(function (v) {
      return (v.options || []).every(function (o, idx) { return String(o) === String(selected[idx]); });
    });
  }

  function updateVariant() {
    var v = currentVariant();
    if (!v || !form) return; // `form` is looked up by id and can legitimately be absent
    var idInput = form.querySelector('[data-variant-id]');
    var atc = pdp.querySelector('[data-atc]');
    if (idInput) idInput.value = v.id;
    document.querySelectorAll('[data-price]').forEach(function (el) { el.textContent = money(v.price); });
    document.querySelectorAll('[data-bnpl-sticky]').forEach(function (el) { el.textContent = money(Math.round(v.price / 4)); });
    var bn = pdp.querySelector('[data-bnpl]'); if (bn && bn.dataset.tpl) bn.textContent = bn.dataset.tpl.replace('%q%', money(Math.round(v.price / 4)));
    var cmp = pdp.querySelector('[data-compare]');
    if (cmp) cmp.style.display = (v.compare_at_price > v.price) ? '' : 'none';
    if (atc && atc.dataset.atcTpl) {
      atc.disabled = !v.available;
      atc.textContent = v.available ? atc.dataset.atcTpl.replace('%price%', money(v.price)) : atc.dataset.soldout;
    } else if (atc) {
      atc.disabled = !v.available;
    }
  }

  /* ---------- qty ---------- */
  var qtyInput = pdp.querySelector('[data-qty-input]');
  pdp.querySelectorAll('[data-qty]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (!qtyInput) return;
      var n = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + parseInt(b.dataset.qty, 10));
      qtyInput.value = n;
    });
  });

  /* ---------- add to cart ---------- */
  function submitAdd(e) {
    if (e) e.preventDefault();
    // Bound to the sticky bar as well as the form, so it can fire with no form present.
    // new FormData(null) throws, and form.submit() below would too.
    if (!form) return;
    // "Often bought together" — extras the shopper ticked
    var extras = [].slice.call(pdp.querySelectorAll('[data-fbt-variant]'))
      .filter(function (c) { return c.checked; })
      .map(function (c) { return { id: parseInt(c.dataset.fbtVariant, 10), quantity: 1 }; });

    if (window.MJCart) {
      var p = window.MJCart.addFromForm(form);
      if (extras.length && p && p.then) {
        p.then(function () {
          var route = (window.MJ && window.MJ.routes && window.MJ.routes.cart_add) || '/cart/add.js';
          return fetch(route, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: extras }) })
            .then(function () { return window.MJCart.refresh(); })
            .then(window.MJCart.open);
        }).catch(function () { /* extras are a nice-to-have; the main item is already in the cart */ });
      }
    } else {
      form.submit();
    }
  }
  if (form) form.addEventListener('submit', submitAdd);
  var stickyBtn = document.querySelector('[data-atc-sticky]');
  if (stickyBtn) stickyBtn.addEventListener('click', submitAdd);

  /* ---------- sticky ATC ---------- */
  var sticky = document.getElementById('mjSticky');
  var buyRow = pdp.querySelector('.t-buy__row');
  if (sticky && buyRow && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var show = !entries[0].isIntersecting && window.innerWidth <= 900;
      sticky.classList.toggle('is-show', show);
      // The bar is translated off-screen when hidden, so its button must leave the a11y
      // tree AND the tab order with it — otherwise screen readers and keyboard users land
      // on an invisible "Add to cart" (WCAG 4.1.2 / 2.4.3).
      if (show) { sticky.removeAttribute('aria-hidden'); sticky.removeAttribute('inert'); }
      else { sticky.setAttribute('aria-hidden', 'true'); sticky.setAttribute('inert', ''); }
    }, { rootMargin: '-90px 0px 0px 0px' }).observe(buyRow);
  }

  /* ---------- delivery estimate (calendar days from the section settings) ---------- */
  var rtl = !!(window.MJ && window.MJ.rtl);
  var months = rtl
    ? ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر']
    : ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var wdays = rtl
    ? ['الأحد', 'الاثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت']
    : ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  function addDays(d, n) { var x = new Date(d); x.setDate(x.getDate() + n); return x; }
  function fmt(d) { return wdays[d.getDay()] + ' ' + d.getDate() + ' ' + months[d.getMonth()]; }
  (function renderDelivery() {
    var minD = parseInt(pdp.dataset.delivMin, 10) || 2;
    var maxD = parseInt(pdp.dataset.delivMax, 10) || minD;
    var now = new Date(), from = addDays(now, minD), to = addDays(now, maxD);
    var w = pdp.querySelector('[data-deliv-window]');
    if (w) w.textContent = (minD === maxD) ? fmt(from) : (fmt(from) + ' – ' + fmt(to));
  })();

  /* ---------- modals ---------- */
  document.querySelectorAll('[data-open-modal]').forEach(function (b) {
    b.addEventListener('click', function () { var m = document.getElementById(b.dataset.openModal); if (m) m.hidden = false; });
  });
  document.querySelectorAll('[data-close-modal]').forEach(function (b) {
    b.addEventListener('click', function () { var m = b.closest('.t-modal'); if (m) m.hidden = true; });
  });
  document.querySelectorAll('.t-modal').forEach(function (m) {
    m.addEventListener('click', function (e) { if (e.target === m) m.hidden = true; });
  });

})();
